import * as en from "./en";
import * as de from "./de";

const locales = [
  {
    locale: "en",
    messages: en,
    loadData: import(`@formatjs/intl-relativetimeformat/locale-data/en`),
  },
  {
    locale: "de",
    messages: de,
    loadData: import(`@formatjs/intl-relativetimeformat/locale-data/de`),
  },
];

export default locales;
